var geoItems = [];
var geoMapItems = [];
var mobile_bp = 1024;
var globalMap, markers = [], normalIcon, selectedIcon, currentSelectedMarker = 1;
const zoomLevel = 10;

function GenerateMapLocations(fnSuccess) {
    $.ajax({
        url: "/api/sitecore/HomeSearchResults/GetLatestHomesCommunitySearch",
        data: null,
        contentType: "application/json;charset=utf-8",
        method: "POST",
        complete: (function (data) {

            console.log("GetLatestHomesCommunitySearch");
            console.log(data);
            var responseJson = data.responseJSON;
            var mapLocationsData = responseJson;
            for (var i = 0; i < mapLocationsData.length; i++) {
                var mapLocation = {};

                //mapLocation.url = mapLocationsData[i].url;
                //mapLocation.balloonText = mapLocationsData[i].balloonText;
                //mapLocation.latitude = mapLocationsData[i].latitude;
                //mapLocation.longitude = mapLocationsData[i].longitude;

                var displayName = "standard";
                //geoItems = [];
                geoItems.push([mapLocationsData[i].city, mapLocationsData[i].latitude, mapLocationsData[i].longitude, displayName, mapLocationsData[i].displayindex]);

                var popupData = '<div class="mobile-info-window">' +
                    
                    '<h3><a class="mobile-info-window-title" href="' +
                    mapLocationsData[i].url +
                    '">' +
                    mapLocationsData[i].title +
                    '</a></h3>' +
                    '<span>' +
                    mapLocationsData[i].city +
                    ', ' +
                    mapLocationsData[i].state +
                    '</span>' +
                    '<h5>' +
                    mapLocationsData[i].shorttitle +
                    '</h5>';
                if (mapLocationsData[i].lowprice !== "$0.00" &&
                    mapLocationsData[i].highprice !== "$0.00" &&
                    mapLocationsData[i].lowsquarefootage != 0 &&
                    mapLocationsData[i].highsquarefootage != 0) {

                    var lowprice = "$" + new Intl.NumberFormat('en-US').format(Math.floor(mapLocationsData[i].lowprice.replace('$', '').replace(/,/g, '')));
                    var highprice = "$" + new Intl.NumberFormat('en-US').format(Math.floor(mapLocationsData[i].highprice.replace('$', '').replace(/,/g, '')));

                    popupData += '<p>' + lowprice + ' - ' + highprice + '</p>' +
                        '<p>Approx.' + mapLocationsData[i].lowsquarefootage + ' - ' + mapLocationsData[i].highsquarefootage + ' sq. ft.</p>';

                }


                if (mapLocationsData[i].numberofqmis > 0) {
                    var qumiData = '<p><a href="' + mapLocationsData[i].url + '#tab-qmi-title" class="plain">' + mapLocationsData[i].numberofqmis + ' Quick Move-ins Available</a></p>';
                    popupData = popupData + qumiData;
                }


                popupData = popupData /*+ '<a href="' + mapLocationsData[i].url + '" class="plain">Visit community</a>'*/ + '</div>';

                geoMapItems.push(popupData);

                //  mapLocationDataList.push(mapLocation);
            }

            if (mapLocationsData.length == 0) {
                CreateEmptyMap();
            } else if (fnSuccess != null) {
                fnSuccess();
            }
        })
    });

}


function CreateEmptyMap() {
    $.ajax({
        url: "/api/sitecore/HomeSearchResults/GetSearchMetro",
        data: null,
        async: false,
        contentType: "application/json;charset=utf-8",
        method: "GET",
        complete: (function (data) {
            var metroMap = data.responseJSON;
            var latLng;
            var longitude;
            var latitude;
            if (metroMap) {
                longitude = metroMap.Longitude;
                latitude = metroMap.Latitude;
                if (longitude && latitude) {
                    latLng = new google.maps.LatLng(latitude, longitude);
                } else if (metroMap.Location) {
                    var googleUrl = "https://maps.googleapis.com/maps/api/geocode/json?address=" + metroMap.location + "&key=AIzaSyDZ_D79dUAf_6gvDjzOx9BTHxkw7Zz4uQk";
                    $.get(googleUrl, function (data, status) {
                        latitude = data.results[0].geometry.location.lat;
                        longitude = data.results[0].geometry.location.lng;
                    });
                    latLng = new google.maps.LatLng(latitude, longitude);
                }
            }

            var mapOptions = $.extend({
                scrollwheel: false,
                center: {
                    lat: latitude,
                    lng: longitude
                },
                zoom: zoomLevel,
                draggable: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            }, mapOptions);

            var map = new google.maps.Map(document.getElementById('slideout-map'), mapOptions);

            if (latLng) {
                map.setCenter(latLng);
            }

            globalMap = map;
        })
    });
}

function GenerateMapLocationsLocal(fnSuccess) {
    geoMapItems = [
        '<div class="infowindow standard">' +
        '<h6>Mesa, AZ</h6>' +
        '<h3><a href="#">Community Name</a></h3>' +
        '<h5>smaller line of text</h5>' +
        '<p><strong>$200,000 - $350,000</strong></p>' +
        '<p>1,500 to 2,700 sq. ft.</p>' +
        '<p><a href="#" class="plain">32 Quick Move-ins Available</a></p>' +
        '<a href="#" class="plain">link to community</a>' +
        '</div>',
        '<div class="infowindow monterey">' +
        '<h6>Mesa, AZ</h6>' +
        '<h3><a href="#">Monterey Community</a></h3>' +
        '<h5>smaller line of text</h5>' +
        '<p><strong>$200,000 - $350,000</strong></p>' +
        '<p>1,500 to 2,700 sq. ft.</p>' +
        '<p><a href="#" class="plain">32 Quick Move-ins Available</a></p>' +
        '<a href="#" class="plain">link to community</a>' +
        '</div>',
        '<div class="infowindow standard">' +
        '<h6>Mesa, AZ</h6>' +
        '<h3><a href="#">Community Name</a></h3>' +
        '<h5>smaller line of text</h5>' +
        '<p><strong>$200,000 - $350,000</strong></p>' +
        '<p>1,500 to 2,700 sq. ft.</p>' +
        '<p><a href="#" class="plain">32 Quick Move-ins Available</a></p>' +
        '<a href="#" class="plain">link to community</a>' +
        '</div>'
    ];
    geoItems = [
        ['Phoenix', 33.4484, -112.0740, 'standard', 1],
        ['Chandler', 33.306160, -111.841250, 'monterey', 2],
        ['Scottsdale', 33.494170, -111.926052, 'standard', 3]
    ];
    fnSuccess();
}

/**
 * You can geolocate this, the code is built out
 * HOWEVER, there's a query limit that causes crashes, so I used lat/lng
 */

var initMap = function () {
    normalIcon = {
        path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
        fillColor: "#002F56",
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 1,
        labelOrigin: new google.maps.Point(0, -30)
    };
    selectedIcon = {
        path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
        fillColor: "#94C947",
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 1,
        labelOrigin: new google.maps.Point(0, -30)
    };


    var generateMapAssets = GenerateMapLocationsLocal;

    generateMapAssets = GenerateMapLocations;

    generateMapAssets(function () {
        showViewMap();
    });
};


var showViewMap = function () {
 
    var map,
        infowindow;
    var mapOptions = $.extend({
        scrollwheel: false,
            center: {
                lat: 33.4484,
                lng: -112.0740
        },
        zoom: zoomLevel,
        draggable: true,
        mapTypeControl: false,
        streetViewControl: false, 
        fullscreenControl: false,
    }, mapOptions);

    // GenerateMapLocations();
    var latngs = geoItems;

    // Templates for the community infowindows
    // Keep html structure, change content in tags
    // Please note the classes in use - "standard" or "monterey"
    var contentString = geoMapItems;

    map = new google.maps.Map(document.getElementById('slideout-map'), mapOptions);
    bounds = new google.maps.LatLngBounds();
    infowindow = new google.maps.InfoWindow();
    locationCount = 0;

    $("#marker-info").data("marker-max", latngs.length);
    if (latngs.length > 0) {
        // Loop through locations and set markers
        for (i = 0; i < latngs.length; i++) {
            // Create the marker for the location
            var markerNum = latngs[i][4];
            var pinColor = (latngs[i][3] === 'standard') ? "#002F56" : "#D3E8EF";
            var pinTextColor = (latngs[i][3] === 'standard') ? "#F7FAFA" : "#002F56";
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(latngs[i][1], latngs[i][2]),
                map: map,
                //label: {
                //    fontFamily: "Font Awesome 5 Free",
                //    text: '\f002'
                //},
                icon: {
                    path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
                    fillColor: pinColor,
                    fillOpacity: 1,
                    strokeColor: '#ffffff',
                    strokeWeight: 1,
                    labelOrigin: new google.maps.Point(0, -30)
                }
            });
            // Add the community/floorplan content to the marker infowindow
            marker.content = contentString[i];
            marker.anchorTag = markerNum;
            //marker.addListener('click', function () {
            google.maps.event.addListener(marker, 'click', function () {

                $(".selected-community").removeClass("selected-community");
                $("#community-search-anchor-" + this.anchorTag).addClass("selected-community");
                $("#marker-info").data("marker-id", this.anchorTag);

                if (this.anchorTag == 1) {
                    $(".community-scrollable-content").scrollTop(0);
                } else {
                    $(".community-scrollable-content").scrollTop($(".community-scrollable-content").scrollTop() + $("#community-search-anchor-" + this.anchorTag).position().top - parseInt($(".community-scrollable-wrapper").css("padding-top")));
                }

                $(".marker-anchor-number").html(this.anchorTag);
                $("#marker-info").html(this.content);
                $("#community-search-anchor-" + this.anchorTag + " .image img").clone().prependTo("#marker-info");
                //$(".community-right-side #marker-info .infowindow").removeClass("infowindow standard monterey");
                $("#marker-content").removeClass("hide");

                /* Info window */

                var $markerContent = $('<div ><div id="info-window-container" style="max-width:250px !important;" ><div id="marker-content"><div id="marker-prev-button" onclick="switchMarkerInfo(-1)" class="marker-controls-button"><img src="/Assets/Corporate/Images/Icons/icon-left-dark.png" alt="Previous Marker"></div><div id="marker-next-button" onclick="switchMarkerInfo(1)" class="marker-controls-button"><img src="/Assets/Corporate/Images/Icons/icon-right-dark.png" alt="Next Marker"></div><div class="marker-anchor-number"></div><div id="marker-info"></div></div></div>');

                $markerContent.find("#info-window-container #marker-info").html(this.content);
                

                $markerContent.find("#info-window-container #marker-info").attr("data-marker-max", latngs.length);

                $markerContent.find("#info-window-container #marker-info").attr("data-marker-id", this.anchorTag);

                if ($("#community-search-anchor-" + this.anchorTag + " .countdown-box").length > 0) {

                    
                    div = $("<div class='priority-registration-countdown'></div>");
                    
                    var countDownBox = $("#community-search-anchor-" + this.anchorTag + " .countdown-box").clone();

                    countDownBox.removeClass("small-12");
                    countDownBox.removeClass("medium-5");

                    div.prependTo($markerContent.find("#info-window-container #marker-info"));

                    countDownBox.prependTo(div);
                } else {

                    $("#community-search-anchor-" + this.anchorTag + " .image img").clone().prependTo($markerContent.find("#info-window-container #marker-info")); //Add image to infowindow
                }


                // End info window

                infowindow.setContent($markerContent.html());
                infowindow.open(map, this);


                $('.infowindow.standard').parent().parent().parent().parent().addClass("infowindow--light-blue");
                $('.infowindow.monterey').parent().parent().parent().parent().addClass("infowindow--blue");

                setMapCenter(this);
               
            });
            
            markers[markerNum] = marker;
           

            // Add this marker to the map bounds
            bounds.extend(new google.maps.LatLng(latngs[i][1], latngs[i][2]));
        }

        let markersCount = {};

        //Removed duplicate entries with lat & lng since those share same pin
        markers.forEach((marker) => {
            let coords = marker.position.lat() + "," + marker.position.lng();
            if(markersCount[coords]){
                markersCount[coords]++;
               
            }else{
                markersCount[coords] = 1;
            }
        });

        //markers: ignore element at index 0
        if (Object.keys(markersCount).length == 1) {
            //Single Pin: Manually zoom and center item inside the map
            map.setCenter(markers[1].position);
            map.setZoom(zoomLevel);
        } else {
            //Multiple Pins : api will figure out zoom and centering
            map.fitBounds(bounds);
        }  
    }
    
    globalMap = map;

    for (i = 1; i < markers.length; i++) {
        (function (i) {
            $("#community-search-anchor-" + i).on('click', function (e) {

                if (e.target == $("#community-search-anchor-" + i + " .open-modal-email")[0]) //Prevent email field lose focus when opening info window.
                    return;

                setMarkerSelected(i);

                $(".selected-community").removeClass("selected-community");
                $("#community-search-anchor-" + i).addClass("selected-community");
                $("#marker-info").data("marker-id", i);

                $(".marker-anchor-number").html(i);
                $("#marker-info").html(markers[i].content);
                
                $("#community-search-anchor-" + i + " .image img").clone().prependTo("#marker-info");

                $("#marker-content").removeClass("hide");

                new google.maps.event.trigger(markers[i], 'click'); //Force marker to reopen the infowindow
              
            });
        })(i);
    }
};




// Reload
var resizeGMap = function () {
    setTimeout(function () {
        initMap();
    }, 250);
};

function scrollTop() {
    var distance = $('.view-map').offset().top;
    var offset = $('.nav--main').height();

    $('html, body').animate({
        scrollTop: (distance - offset)
    }, 1000);
}

function setMarkerSelected(selectedMarkerNum) {
    markers[currentSelectedMarker].setIcon(normalIcon);
    markers[selectedMarkerNum].setIcon(selectedIcon);
    currentSelectedMarker = selectedMarkerNum;
}

$(function () {

    if ($('.view-map').length) {
        resizeGMap();
        $(window).off('resize');
    }

    if ($(window).width() < mobile_bp) {
        $(".community-right-side").css("display", "none");
        $('.view-map-button').css("display", "none");
        $(".footer-container").css("display", "none");
        $(".view-list-button").css("display", "block");
    }

    $("#marker-content #marker-info-hide-button").on("click", function () {
        $("#marker-content").addClass("hide");
    });
    $("#marker-content").on("swipeleft", function (event) {
        switchMarker(1);
    });
    $("#marker-content").on("swiperight", function (event) {
        switchMarker(-1);
    });
    $('.view-list-button').on("click", function () {
        $(".community-right-side").css("display", "block");
        $(".community-left-side").css("display", "none");
        $('.view-map-button').css("display", "block");
        $(".footer-container").css("display", "block");
        $(".community-scrollable-content").scrollTop($(".community-scrollable-content").scrollTop() + $(".selected-community").position().top - parseInt($(".community-scrollable-wrapper").css("padding-top")));
    });
    $('.view-map-button').on("click", function () {
        $(".community-right-side").css("display", "none");
        $(".community-left-side").css("display", "block");
        $(".community-left-side").focus();
        $(".footer-container").css("display", "none");
        
    });
    $('#marker-prev-button').on("click", function () {
        switchMarker(-1);
    });
    $('#marker-next-button').on("click", function () {
        switchMarker(1);
    });
});

$(window).load(function () {
    resizeCommunityLayout();
    $(window).resize(function () {
        resizeCommunityLayout();
    });
});

function resizeCommunityLayout() {
    document.documentElement.style.setProperty('--vh', (window.innerHeight / 100) + 'px');
    var topPadding = calculateTopPadding();
    $(".community-left-side, .community-scrollable-wrapper").css("padding-top", topPadding + "px");
    if ($(window).width() > mobile_bp) {
        $("#basicFilter").css("margin-top", (topPadding - $("#basicFilter").height()) + "px");
        $("#basicFilter").css("padding-top", 0);
        $("#mobileSearchFilter").css("padding-top", 0);
    } else {
        $("#basicFilter").css("padding-top", topPadding + "px");
        $("#basicFilter").css("margin-top", 0);
        $("#mobileSearchFilter").css("padding-top", (topPadding - $("#mobileSearchFilter").height()) + "px");
    }
}

function calculateTopPadding() {
    var calc = 0;
    if ($(".promotion-top").length > 0) {
        calc += $(".promotion-top").height();
    }
    if ($(".nav--top").length > 0) {
        calc += $(".nav--top").height();
    }
    if ($(".nav--bottom").length > 0) {
        calc += $(".nav--bottom").height();
    }
    if ($("#basicFilter").length > 0 && $(window).width() > mobile_bp) {
        calc += $("#basicFilter").height();
    }
    if ($("#mobileSearchFilter").length > 0 && $(window).width() <= mobile_bp) {
        calc += $("#mobileSearchFilter").height();
    }
    return calc;
}

function switchMarkerInfo(direction) {
    var maxId = $("#marker-info").data("marker-max");
    var currentId = $("#marker-info").data("marker-id");
    var newId = direction > 0 ? (currentId % maxId) + 1 : currentId == 1 ? maxId : currentId - 1;

    new google.maps.event.trigger(markers[newId], 'click'); //Force marker to reopen the infowindow

    $("#marker-info").data("marker-id", newId);
    $(".selected-community").removeClass("selected-community");
    $("#community-search-anchor-" + newId).addClass("selected-community");
    $(".marker-anchor-number").html(newId);
    $("#marker-info").html(markers[newId].content);
    

    if ($("#community-search-anchor-" + newId + " .countdown-box").length > 0) {


        div = $("<div class='priority-registration-countdown'></div>");
        
        var countDownBox = $("#community-search-anchor-" + newId + " .countdown-box").clone();

        countDownBox.removeClass("small-12");
        countDownBox.removeClass("medium-5");

        div.prependTo($("#marker-info"));

        countDownBox.prependTo(div);
 
    } else {
        
        $("#community-search-anchor-" + newId + " .image img").clone().prependTo($("#marker-info")); //Add image to infowindow
    }
    setMarkerSelected(newId);
    //setMapCenter(markers[newId]);
}

function switchMarker(direction) {
    var maxId = $("#marker-info").data("marker-max");
    var currentId = $("#marker-info").data("marker-id");
    var newId = direction > 0 ? (currentId % maxId) + 1 : currentId == 1 ? maxId : currentId - 1;
    $("#marker-info").data("marker-id", newId);
    $(".selected-community").removeClass("selected-community");
    $("#community-search-anchor-" + newId).addClass("selected-community");
    $(".marker-anchor-number").html(newId);
    $("#marker-info").html(markers[newId].content);

    if ($("#community-search-anchor-" + newId + " .countdown-box").length > 0) {

        div = $("<div class='priority-registration-countdown'></div>");

        var countDownBox = $("#community-search-anchor-" + newId + " .countdown-box").clone();

        countDownBox.removeClass("small-12");
        countDownBox.removeClass("medium-5");

        div.prependTo($("#marker-info"));

        countDownBox.prependTo(div);

    } else {
        $("#community-search-anchor-" + newId + " .image img").clone().prependTo($("#marker-info")); //Add image to infowindow
    }

    setMarkerSelected(newId);
    setMapCenter(markers[newId]);
}

function setMapCenter(marker) {
    var divHeightOfTheMap = document.getElementById('slideout-map').clientHeight;
    var divHeightOfMarkerContent = document.getElementById('marker-content').clientHeight;
    var offSetFromTop = (divHeightOfTheMap - divHeightOfMarkerContent) / 2;
    globalMap.setCenter(marker.getPosition());

    if (divHeightOfMarkerContent > 0) {
        globalMap.panBy(0, divHeightOfTheMap / 2 - offSetFromTop);
    }
}